import { render } from "./Recepcion.vue?vue&type=template&id=6bfba172&scoped=true"
import script from "./Recepcion.vue?vue&type=script&lang=js"
export * from "./Recepcion.vue?vue&type=script&lang=js"

import "./Recepcion.vue?vue&type=style&index=0&id=6bfba172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfba172"]])

export default __exports__